import { MakeCall } from './createMakeCall';

const markNotificationAsRead =
  (makeCall: MakeCall) => (notificationId: number) =>
    makeCall<undefined>('PUT', `/api/v2/notifications/read`, {
      query: { id: notificationId },
    });
export { markNotificationAsRead };
